import configMcom from './config-mcom.js';
import configBcom from './config-bcom.js';

const entryPoint = process.env.VITE_ENTRY_POINT || import.meta.env.VITE_ENTRY_POINT;

export default entryPoint === 'bcom' ? configBcom : configMcom;
